__turbopack_export_value__({
  "body-logo-18": "CardWithTitle-module-scss-module__mYvGNa__body-logo-18",
  "body-text-12": "CardWithTitle-module-scss-module__mYvGNa__body-text-12",
  "body-text-14": "CardWithTitle-module-scss-module__mYvGNa__body-text-14",
  "body-text-16": "CardWithTitle-module-scss-module__mYvGNa__body-text-16",
  "body-text-18": "CardWithTitle-module-scss-module__mYvGNa__body-text-18",
  "body-text-20": "CardWithTitle-module-scss-module__mYvGNa__body-text-20",
  "body-text-24": "CardWithTitle-module-scss-module__mYvGNa__body-text-24",
  "body-text-24-2": "CardWithTitle-module-scss-module__mYvGNa__body-text-24-2",
  "body-text-heading-2": "CardWithTitle-module-scss-module__mYvGNa__body-text-heading-2",
  "body-text-heading-3": "CardWithTitle-module-scss-module__mYvGNa__body-text-heading-3",
  "body-text-medium-14": "CardWithTitle-module-scss-module__mYvGNa__body-text-medium-14",
  "body-text-medium-16": "CardWithTitle-module-scss-module__mYvGNa__body-text-medium-16",
  "body-text-medium-18": "CardWithTitle-module-scss-module__mYvGNa__body-text-medium-18",
  "body-text-medium2-18": "CardWithTitle-module-scss-module__mYvGNa__body-text-medium2-18",
  "body-text2-14": "CardWithTitle-module-scss-module__mYvGNa__body-text2-14",
  "body-text2-16": "CardWithTitle-module-scss-module__mYvGNa__body-text2-16",
  "button-primary-text": "CardWithTitle-module-scss-module__mYvGNa__button-primary-text",
  "button-text": "CardWithTitle-module-scss-module__mYvGNa__button-text",
  "button2-text": "CardWithTitle-module-scss-module__mYvGNa__button2-text",
  "card": "CardWithTitle-module-scss-module__mYvGNa__card",
  "card-shadow": "CardWithTitle-module-scss-module__mYvGNa__card-shadow",
  "card__date": "CardWithTitle-module-scss-module__mYvGNa__card__date",
  "card__imageWrapper": "CardWithTitle-module-scss-module__mYvGNa__card__imageWrapper",
  "card__inner": "CardWithTitle-module-scss-module__mYvGNa__card__inner",
  "card__title": "CardWithTitle-module-scss-module__mYvGNa__card__title",
  "effect-menu": "CardWithTitle-module-scss-module__mYvGNa__effect-menu",
  "header-1": "CardWithTitle-module-scss-module__mYvGNa__header-1",
  "main-container": "CardWithTitle-module-scss-module__mYvGNa__main-container",
  "main-footer-container": "CardWithTitle-module-scss-module__mYvGNa__main-footer-container",
  "main-header-container": "CardWithTitle-module-scss-module__mYvGNa__main-header-container",
  "txt-12-bold": "CardWithTitle-module-scss-module__mYvGNa__txt-12-bold",
  "txt-14-bold": "CardWithTitle-module-scss-module__mYvGNa__txt-14-bold",
  "txt-14-bold-caps": "CardWithTitle-module-scss-module__mYvGNa__txt-14-bold-caps",
  "txt-14-med": "CardWithTitle-module-scss-module__mYvGNa__txt-14-med",
  "txt-16-bold": "CardWithTitle-module-scss-module__mYvGNa__txt-16-bold",
  "txt-16-med": "CardWithTitle-module-scss-module__mYvGNa__txt-16-med",
  "txt-18-bold": "CardWithTitle-module-scss-module__mYvGNa__txt-18-bold",
  "txt-18-medium": "CardWithTitle-module-scss-module__mYvGNa__txt-18-medium",
  "txt-18-medium-24": "CardWithTitle-module-scss-module__mYvGNa__txt-18-medium-24",
  "txt-24-semi": "CardWithTitle-module-scss-module__mYvGNa__txt-24-semi",
});
